import collapse from '@/images/ArrowButtonBright.svg';
import { css, Global } from '@emotion/react';
import { useTheme } from '@mui/material';
import { setHighlighterStyle, setTransformerStyle } from 'polotno/config';

function AdvancedEditorStyles() {
    const theme = useTheme();

    setTransformerStyle({
        anchorStroke: theme.colors.primary.main,
        borderStroke: theme.colors.primary.main,
    });

    setHighlighterStyle({
        stroke: theme.colors.primary.main,
    });

    return (
        <Global
            styles={css`
                .bp5-dark div[data-popper-arrow] {
                    width: 56px;
                    height: 20px;
                    right: -37px;
                    background-image: url(${collapse});
                    background-color: ${theme.colors.secondary.main};
                    background-repeat: no-repeat;
                    border-radius: 7px 7px 0 0;
                    transform: rotate(90deg);
                    background-position: center;
                    &:hover {
                        cursor: pointer;
                    }
                }

                // Rename the Position button to Arrange
                .bp5-icon-layers + .bp5-button-text {
                    font-size: 0;
                }

                .bp5-icon-layers + .bp5-button-text::before {
                    font-size: 14px;
                    content: 'Arrange';
                }

                // Contextual menu
                .bp5-navbar:has(> .bp5-navbar-group.bp5-align-left) {
                    border-radius: 8px !important;
                    box-shadow:
                        0.3px 0.8px 1.1px 0px rgba(187, 187, 187, 0.12),
                        1.1px 2.8px 3.9px -0.4px rgba(187, 187, 187, 0.17),
                        2.4px 6.1px 8.6px -0.8px rgba(187, 187, 187, 0.23),
                        5.3px 13.3px 18.8px -1.2px rgba(187, 187, 187, 0.29) !important;
                    height: 42px !important;
                    padding: 0 !important;

                    > .bp5-navbar-group.bp5-align-left {
                        width: 100%;
                        height: 42px !important;
                        display: flex;
                        padding: 8px 12px;
                        gap: 18px;

                        > .bp5-button.bp5-minimal {
                            font-weight: 600;
                        }
                    }
                }

                // Hide Align options
                .bp5-popover-content {
                    > ul[style*='280px'] {
                        > li:nth-child(3) {
                            display: none !important;
                        }
                        > div:nth-child(4) {
                            display: none !important;
                        }
                    }
                }

                .bp5-dark div[data-popper-arrow] svg {
                    display: none;
                }

                .pointer {
                    display: none;
                }

                .bp5-dark .bp5-navbar {
                    background: #303130 !important;
                }

                .bp5-tabs::after {
                    font-weight: 600 !important;
                    font-family: ${theme.fonts.primary} !important;
                }

                .bp5-button.bp5-minimal.polotno-close-panel {
                    background-color: ${theme.colors.secondary[800]} !important;
                    &:hover {
                        background-color: ${theme.colors.secondary[700]} !important;
                    }
                    &::after {
                        font-family: ${theme.fonts.primary} !important;
                        font-weight: 600 !important;
                        left: 0;
                        top: 155% !important;
                    }
                }

                .bp5-navbar {
                    box-shadow: none !important;
                    -webkit-box-shadow: none !important;
                    border: none !important;
                }

                .bp5-dark .polotno-panel-container {
                    background: ${theme.colors.secondary.main} !important;
                    box-shadow: none !important;
                    overflow: auto;
                }

                .bp5-dark .polotno-side-tabs-container {
                    background: ${theme.colors.secondary.main};
                    padding: 0 6px;
                    min-width: 82px;
                }

                .bp5-dark .polotno-side-tabs-container .polotno-side-panel-tab {
                    margin-top: 8px;
                    border-radius: 8px;
                    height: 70px;
                }

                .bp5-dark .polotno-side-tabs-container .polotno-side-panel-tab.active,
                .bp5-dark .polotno-side-tabs-container .polotno-side-panel-tab:hover {
                    background: ${theme.colors.black[900]};
                    color: white !important;
                }
                .polotno-workspace-inner {
                    overflow: hidden !important;
                }

                .polotno-side-tabs-inner {
                    height: 100%;
                }

                .polotno-side-panel-tab {
                    & div:last-child {
                        font-size: 10px;
                        font-weight: 600;
                    }
                }

                .bp5-popover2-target {
                    height: 38px !important;
                    & > button span.bp5-button-text {
                        color: ${theme.colors.secondary.main};
                        font-size: 15px !important;
                        font-weight: 600 !important;
                    }
                    & > button {
                        height: 100% !important;
                        max-height: 100% !important;
                        border-radius: 8px;
                    }
                }

                .bp5-navbar-group.bp5-align-right {
                    & > .bp5-button {
                        height: 38px;
                        font-weight: 600;
                        font-family: ${theme.fonts.primary};
                        font-size: 15px;
                        border-radius: 8px;
                        position: relative;
                        color: ${theme.colors.secondary.main};
                        margin-right: 16px;

                        &:not(:last-child)::before {
                            content: '';
                            width: 1px;
                            height: 20px;
                            background-color: rgba(17, 20, 24, 0.15);
                            position: absolute;
                            right: -16px;
                            top: 9px;
                        }
                    }
                }

                .konvajs-content {
                    position: relative;
                    top: 15px;
                }

                // Customizing the search input in the font family dropdown
                .bp5-popover2 {
                    border-radius: 12px;
                    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.25);
                    background-color: #fff;

                    .bp5-popover2-arrow {
                        display: none;
                    }

                    .bp5-input-group {
                        height: 38px;
                        margin: 16px 16px 0;
                    }

                    .bp5-icon.bp5-icon-search {
                        color: ${theme.colors.secondary[900]};
                        margin: 10px 0 10px 12px;

                        svg {
                            height: 18px;
                            width: 18px;
                        }
                    }

                    .bp5-input {
                        border-radius: 8px;
                        border: 1px solid ${theme.colors.black[300]};
                        outline: none;
                        box-shadow: none;
                        caret-color: ${theme.colors.primary[900]};
                        height: 100%;
                    }

                    .bp5-input-group .bp5-input:not(:first-child) {
                        padding-left: 36px;
                    }

                    .bp5-popover2-content {
                        border-radius: 8px;
                    }

                    .bp5-popover2-content > div > div:nth-child(2) > div {
                        width: 100% !important;
                        border-radius: 8px;

                        .bp5-menu-item {
                            margin: 8px;
                            width: calc(100% - 16px);

                            border-radius: 8px;

                            :hover {
                                background-color: ${theme.colors.black[100]};
                            }

                            &.bp5-selected {
                                background-color: ${theme.colors.black[100]};
                            }

                            div {
                                display: flex;
                                align-items: center;
                            }
                        }
                    }
                }
            `}
        />
    );
}

/**
 * customize dropdown to look like mui (including arrow)
 */

export default AdvancedEditorStyles;
